<template>
  <div class="mi-site mi-site--page">
    <a class="mi-skip" href="#main">Skip to content</a>
    <MarketingHeader />

    <main id="main" class="mi-404">
      <div class="mi-hero-atmosphere" aria-hidden="true">
        <span class="mi-hero-orb mi-hero-orb-a"></span>
        <span class="mi-hero-orb mi-hero-orb-b"></span>
        <span class="mi-hero-orb mi-hero-orb-c"></span>
      </div>

      <div class="mi-shell mi-404-grid">
        <div class="mi-404-copy">
          <p class="mi-kicker">
            <span class="mi-kicker-dot" aria-hidden="true"></span>
            Status · Withdrawn
          </p>
          <h1>
            This listing
            <span class="mi-hero-line">isn’t on the <span class="mi-grad">market</span>.</span>
          </h1>
          <p class="mi-lede mi-lede--left">
            We ran reconcile. The MLS returned zero rows for
            <span class="mi-404-path">{{ path }}</span>.
            Either it purged, never listed, or someone invented a street.
          </p>
          <div class="mi-hero-actions mi-404-actions">
            <router-link to="/" class="mi-btn">Back to search</router-link>
            <router-link to="/mls-directory" class="mi-ghost">Check the directory</router-link>
          </div>
        </div>

        <article class="mi-listing mi-404-card" aria-hidden="true">
          <div class="mi-404-photo">
            <img src="/hero-listings/03.jpg" alt="" />
            <span class="mi-404-stamp">Off market</span>
          </div>
          <div class="mi-listing-body">
            <p class="mi-listing-price">$404</p>
            <p class="mi-listing-addr">404 Missing Lane</p>
            <p class="mi-listing-meta">0 BD  ·  0 BA  ·  0 SF</p>
          </div>
        </article>
      </div>
    </main>

    <MarketingFooter />
  </div>
</template>

<script>
import MarketingHeader from './MarketingHeader'
import MarketingFooter from './MarketingFooter'
import '../assets/marketing.css'

export default {
  name: 'NotFoundPage',
  components: { MarketingHeader, MarketingFooter },
  computed: {
    path() {
      return this.$route.fullPath || '/404'
    },
  },
}
</script>
